// Function to get category-specific gradient colors
export const getCategoryGradient = (category: string): string => {
  switch (category) {
    case "Tiles":
      return "linear-gradient(135deg, #2196f3 0%, #1976d2 100%)"; // Blue gradient for tiles
    case "Granite":
      return "linear-gradient(135deg, #795548 0%, #5d4037 100%)"; // Brown gradient for granite
    case "CP Fittings":
      return "linear-gradient(135deg, #9e9e9e 0%, #616161 100%)"; // Grey gradient for chrome
    case "Bath Fittings":
      return "linear-gradient(135deg, #00bcd4 0%, #0097a7 100%)"; // Cyan gradient for bath
    case "Sanitary Ware":
      return "linear-gradient(135deg, #4caf50 0%, #388e3c 100%)"; // Green gradient for sanitary
    case "Bath Accessories":
      return "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)"; // Orange gradient for accessories
    case "Home Decor":
      return "linear-gradient(135deg, #e91e63 0%, #c2185b 100%)"; // Pink gradient for decor
    case "Kitchen Fittings":
      return "linear-gradient(135deg, #673ab7 0%, #512da8 100%)"; // Purple gradient for kitchen
    default:
      return "linear-gradient(135deg, #1a237e 0%, #3949ab 100%)"; // Default gradient
  }
};

// Handle contact actions
export const handleCall = () => {
  window.open("tel:+917897239423", "_self");
};

export const handleWhatsApp = (productTitle?: string) => {
  const message = productTitle
    ? `Hi! I'm interested in ${productTitle}. Can you provide more details?`
    : "Hi! I would like to know more about your products and services.";
  window.open(
    `https://wa.me/917897239423?text=${encodeURIComponent(message)}`,
    "_blank"
  );
};

export const handleShare = (product?: {
  title: string;
  description: string;
}) => {
  if (navigator.share && product) {
    navigator.share({
      title: product.title,
      text: product.description,
      url: window.location.href,
    });
  } else {
    navigator.clipboard.writeText(window.location.href);
  }
};
